import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY } from 'app-constants'
import { BaseCard } from '../base-card'

export function ServiceOrdersCard() {
  const dispatch = useDispatch()

  function handleClick() {
    dispatch(setDrawer(DRAWER_KEY.SERVICE_ORDERS))
  }

  return (
    <BaseCard onClick={handleClick} text='Ordens de serviço' icon={<STATICS.CONFIGURATION />} />
  )
}
